import { render, staticRenderFns } from "./attrList.vue?vue&type=template&id=13248f37&scoped=true"
import script from "./attrList.vue?vue&type=script&lang=js"
export * from "./attrList.vue?vue&type=script&lang=js"
import style0 from "./attrList.vue?vue&type=style&index=0&id=13248f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13248f37",
  null
  
)

export default component.exports